var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowerRainNightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.031,
    height: 24.047,
    viewBox: "0 0 24.031 24.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shower-rain-night-icon",
    transform: "translate(29.023 -28.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 24,
    height: 24,
    transform: "translate(-29 29)",
    fill: "rgba(252,252,252,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    y2: 2,
    transform: "translate(-21 48)",
    fill: "none",
    stroke: "#388cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-2",
    y2: 2,
    transform: "translate(-21 42)",
    fill: "none",
    stroke: "#388cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-3",
    y2: 2,
    transform: "translate(-13 48)",
    fill: "none",
    stroke: "#388cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-4",
    y2: 2,
    transform: "translate(-13 42)",
    fill: "none",
    stroke: "#388cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-5",
    y2: 2,
    transform: "translate(-17 50)",
    fill: "none",
    stroke: "#388cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-6",
    y2: 2,
    transform: "translate(-17 44)",
    fill: "none",
    stroke: "#388cff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M-8.992,45.581c3.551-1.553,4.391-6.733.076-9.3A2.207,2.207,0,0,0-10.041,36h-2.211c-1.457-5.643-8.585-8.318-13.707-3.5a3.685,3.685,0,0,0-.566.68,8.2,8.2,0,0,0,1.533,11.07",
    fill: "none",
    stroke: "#364456",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerRainNightIcon);
export default __webpack_public_path__ + "static/media/shower-rain-night-icon.1ece4729d258d004480ff68a3b23c1db.svg";
export { ForwardRef as ReactComponent };